// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".headerTitle[data-v-6ed18e86]{margin-bottom:25px}.headerTitle .searchBox[data-v-6ed18e86]{display:flex;margin:25px 0}.headerTitle .searchBox .left[data-v-6ed18e86]{width:80%}.headerTitle .searchBox .left .wid[data-v-6ed18e86]{width:20%}.headerTitle .searchBox .right[data-v-6ed18e86]{width:20%;text-align:right}", ""]);
// Exports
module.exports = exports;
